<mat-dialog-content>
  <div class="popup-head">Add {{text}}</div>
  <!-- <div *ngFor="let item of noAlleregns; let i = index"> -->
  <div>
    <div class="popup-subhead">{{text}} Name</div>
    <div style="display: flex">
      <input
        type="text"
        placeholder="Enter {{text}} Name"
        [(ngModel)]="inputValue"
        class="form-control popup-input"
      />
      <!-- <img
        src="../../../assets/images/addTimeComp.png"
        alt=""
        class="popup-addBtnIcon"
        *ngIf="i==0"
        (click)="addInput()"
      /> -->
    </div>
  </div>
  <div class="buttomPartAddResto">
    <div mat-dialog-close mat-dialog-close="false" class="common closeBtn">
      Close
    </div>
    <div mat-dialog-close [mat-dialog-close]="inputValue" class="common submitBtn">
      Submit
    </div>
  </div>
</mat-dialog-content>
<style>
  ::ng-deep .mat-dialog-container {
    padding: 0;

    overflow-x: hidden;
  }
  ::ng-deep .mat-dialog-content::-webkit-scrollbar {
    display: none;
  }
  .popup-head {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    color: rgba(57, 64, 70, 1);
    background-color: rgba(238, 238, 238, 1);
    width: 873px;
    height: 52px;
    display: flex;
    align-items: center;
    padding-left: 25px;
  }
  .popup-subhead {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: rgba(23, 83, 117, 1);
    padding-left: 25px;
    margin-top: 20px;
  }
  .popup-input {
    width: 322px;
    margin: 20px;
  }
  .popup-addBtnIcon {
    width: 30px;
    height: 30px;
    margin-top: 25px;
    cursor: pointer;
  }
  .buttomPartAddResto {
    display: flex;
    justify-content: end;
  }
  .common {
    padding: 5px 29px;
    margin: 30px 9px;
    cursor: pointer;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    border-radius: 6px;
  }
  .common:hover {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
      rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  }

  .closeBtn {
    color: rgba(57, 64, 70, 1);
    border: 2px solid rgba(57, 64, 70, 1);
  }

  .submitBtn {
    color: rgba(255, 255, 255, 1);
    background: linear-gradient(90.17deg, #2fb9e3 -97.61%, #56ab51 120.65%);
    border-radius: 6px;
  }
</style>
